var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeacher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1428_7189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.9375 15.8438C2.29688 15.1903 3.6625 13.8835 6.25 13.8835C8.8375 13.8835 10.2031 12.3153 10.5625 11.5312M6.25 6.5V4.34375C6.25 3.54984 6.89359 2.90625 7.6875 2.90625H14.875C15.6689 2.90625 16.3125 3.54984 16.3125 4.34375V10.0938C16.3125 10.8877 15.6689 11.5312 14.875 11.5312H12.5317M9.125 5.78125H13.4375M7.6875 10.0938C7.6875 10.8877 7.04391 11.5312 6.25 11.5312C5.45609 11.5312 4.8125 10.8877 4.8125 10.0938C4.8125 9.29984 5.45609 8.65625 6.25 8.65625C7.04391 8.65625 7.6875 9.29984 7.6875 10.0938Z",
    stroke: "#1E2D66",
    strokeWidth: 1.4375,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2812 8.65625H13.4375",
    stroke: "#1E2D66",
    strokeWidth: 1.4375,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1428_7189"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.25,
    height: 17.25,
    fill: "white",
    transform: "translate(0.5 0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacher);
export default __webpack_public_path__ + "static/media/Teacher.d0041019e4ff8dbe53e1fa07c30e8315.svg";
export { ForwardRef as ReactComponent };